import { cn } from "@/lib/utils";

const UPPER = ["18","17","16","15","14","13","12","11","21","22","23","24","25","26","27","28"];
const LOWER = ["48","47","46","45","44","43","42","41","31","32","33","34","35","36","37","38"];

const STATUS_COLOR = {
  "Missing": "bg-slate-200 text-slate-500 dark:bg-slate-700 dark:text-slate-300 line-through",
  "Root stump": "bg-amber-100 text-amber-700 dark:bg-amber-500/20 dark:text-amber-300",
  "Mobile": "bg-red-100 text-red-600 dark:bg-red-500/20 dark:text-red-300",
  "Grossly carious": "bg-orange-100 text-orange-600 dark:bg-orange-500/20 dark:text-orange-300",
};

export function FdiChart({ findings = [], onToggle }) {
  const map = {};
  findings.forEach((f) => { map[String(f.fdi)] = f; });

  const Tooth = ({ n }) => {
    const f = map[n];
    return (
      <button
        type="button"
        onClick={() => onToggle?.(n)}
        data-testid={`tooth-${n}`}
        className={cn(
          "flex h-9 w-9 sm:h-10 sm:w-10 shrink-0 items-center justify-center rounded-lg border text-[11px] font-bold transition-colors",
          f ? STATUS_COLOR[f.status] || "bg-[#E8F7F0] text-[#008F4D]" : "border-[#E2E8F0] dark:border-[#223139] text-[#687173] dark:text-[#8B9698] hover:border-[#00A85A]/50"
        )}
        title={f ? `${n} — ${f.status}` : n}
      >
        {n}
      </button>
    );
  };

  return (
    <div className="space-y-2">
      <div className="flex flex-wrap justify-center gap-1.5">{UPPER.map((n) => <Tooth key={n} n={n} />)}</div>
      <div className="text-center text-[10px] font-bold uppercase tracking-wider text-[#8B9698]">Maxilla / Mandible</div>
      <div className="flex flex-wrap justify-center gap-1.5">{LOWER.map((n) => <Tooth key={n} n={n} />)}</div>
      <div className="flex flex-wrap justify-center gap-3 pt-2 text-[10px] text-[#687173] dark:text-[#8B9698]">
        {Object.keys(STATUS_COLOR).map((s) => (
          <span key={s} className="flex items-center gap-1"><span className={cn("h-2.5 w-2.5 rounded", STATUS_COLOR[s].split(" ")[0])} />{s}</span>
        ))}
      </div>
    </div>
  );
}
